var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArgosUserUnassignedPurple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45.68 39.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #8a397e;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 2px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\xEB\\xEE\\xE9_1",
    "data-name": "\\u2018\\xEB\\xEE\\xE9_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "20.21 34.56 17.7 24.36 15.19 34.56 17.7 37.45 20.21 34.56"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1,37.74l.98-9.71c.28-2.77,2.39-5.01,5.13-5.46l6.1-1,4.49,2.5,4.49-2.5,6.1,1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.21,
    y1: 21.57,
    x2: 13.86,
    y2: 20.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 21.54,
    y1: 20.38,
    x2: 22.19,
    y2: 21.57
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.98,8.54c.75.3.89.96.84,1.7,0,0-.27,2.3-1,2.56-.73,3.1-2.73,6.03-6.12,6.03-3.15,0-5.27-2.92-6.08-6.01-.75-.25-1.04-2.58-1.04-2.58-.05-.74.09-1.4.84-1.7,0,0-.33-5.17,1.79-6.2.73-.36-.09-1,2.33-1.28,2.01-.23,4.78.19,6.09,1.27.92.76,2.5,1.95,2.35,6.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.19,3.43s0,2.93,4.98,1.38c2.71-.84,6.09-1.29,6.58.79"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.49,36.42l-8.75-15.79c-.58-1.05-2.09-1.05-2.68,0l-8.75,15.79c-.57,1.02.17,2.27,1.34,2.27h17.5c1.17,0,1.9-1.25,1.34-2.27Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 34.4,
    y1: 26.01,
    x2: 34.4,
    y2: 32.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 34.4,
    y1: 35.24,
    x2: 34.4,
    y2: 35.24
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArgosUserUnassignedPurple);
export default __webpack_public_path__ + "static/media/Argos - User Unassigned - Purple.b01909753efb2347622074b14669b80f.svg";
export { ForwardRef as ReactComponent };